var STRING_TYPE = 'string';
var BOOLEAN_TYPE = 'boolean';
var OBJECT_TYPE = 'object';
var FUNCTION_TYPE = 'function';
function isType(v, t) {
    return typeof v === t;
}

function hiddenProperty(obj, props) {
    for (var key in props) {
        Object.defineProperty(obj, key, {
            enumerable: false,
            value: props[key],
        });
    }
}

var nativeGlobalThis = ( typeof globalThis === OBJECT_TYPE && globalThis
    || typeof window === OBJECT_TYPE && window
    || typeof global === OBJECT_TYPE && global
    || {});
var console = nativeGlobalThis.console;
var document$1 = nativeGlobalThis.document || {};
var location = nativeGlobalThis.location || {};
var navigator = (nativeGlobalThis.navigator || {});
var connection = navigator.connection;
var performance$1 = nativeGlobalThis.performance;
var noop = function () { };
var perfNow = isType(performance$1 && performance$1.now, FUNCTION_TYPE)
    ? function () { return performance$1.now(); }
    : Date.now;
var setTimeout$1 = nativeGlobalThis.setTimeout.bind(nativeGlobalThis);
var nextFrame = (nativeGlobalThis.requestAnimationFrame || setTimeout$1).bind(nativeGlobalThis);
var addEventListener$1 = (nativeGlobalThis.addEventListener || noop).bind(nativeGlobalThis);

var nil = null;
var undef = undefined;
var DEFAULT_UNIT = 'ms';
function create(opts) {
    opts = opts || {};
    var idx;
    var cid = 0;
    var tmpEntry;
    var api;
    var now = opts.now || perfNow;
    var warn = opts.warn;
    var prefix = opts.prefix || '';
    var addons = opts.addons || [];
    var activeGroups = [];
    var notify = function (hook, entry, autoMeasurable) {
        idx = addons.length;
        while (idx--) {
            addons[idx][hook](entry, autoMeasurable);
        }
    };
    var createEntry = function (name, parent, timers, unit, isGroup, start, end, isolate, meta) {
        name = prefix + name;
        if (parent === api || isolate) {
            parent = !isolate && activeGroups[0] || nil;
        }
        if (timers[name]) {
            warn && warn("Timer '" + name + "' exists");
        }
        var autoMeasurable = start == nil;
        var entry = timers[name] = {
            id: ++cid,
            name: name,
            parent: parent,
            unit: unit || DEFAULT_UNIT,
            start: autoMeasurable ? now() : start,
            end: end != nil ? end : nil,
            meta: meta,
        };
        hiddenProperty(entry, {
            stop: function (time, meta) {
                if (time != nil && !(time >= 0)) {
                    meta = time;
                    time = undef;
                }
                entry.meta = entry.meta || meta;
                entry.end = time == nil ? now() : time;
                timers[name] = nil;
                if (isGroup) {
                    idx = activeGroups.length;
                    while (idx--) {
                        if (activeGroups[idx] === entry) {
                            activeGroups.splice(idx, 1);
                        }
                    }
                }
                notify('end', entry, autoMeasurable);
                return entry;
            },
        });
        if (parent) {
            if (parent.end !== nil && end == nil) {
                warn && warn("Timer '" + name + "' stopped");
            }
            else {
                entry.unit = parent.unit;
                // (parent as GroupEntry).active++;
                parent.entries.push(entry);
            }
        }
        function entryEnd(name, end, meta) {
            name = prefix + name; // mutation
            tmpEntry = timers[name];
            if (tmpEntry) {
                isType(tmpEntry.stop, FUNCTION_TYPE)
                    ? tmpEntry.stop(end, meta)
                    : warn && warn("Timer '" + name + "'.stop is not a func", { entry: tmpEntry });
            }
            else {
                warn && warn("Timer '" + name + "' not exists");
            }
        }
        if (isGroup) {
            // (entry as GroupEntry).active = 0;
            entry.entries = [];
            hiddenProperty(entry, {
                add: function (name, start, end, unit, meta) {
                    return createEntry(name, entry, timers, unit, 0, start, end).stop(end, meta);
                },
                time: function (name, start, unit) {
                    if (!(start >= 0)) {
                        unit = start;
                        start = undef;
                    }
                    return createEntry(name, entry, timers, unit, undef, start);
                },
                group: function (name, startOrIsolateOrUnit, isolateOrUnit, unit) {
                    if (isType(startOrIsolateOrUnit, BOOLEAN_TYPE)) {
                        unit = isolateOrUnit;
                        isolateOrUnit = startOrIsolateOrUnit;
                        startOrIsolateOrUnit = nil;
                    }
                    if (isType(startOrIsolateOrUnit, STRING_TYPE)) {
                        unit = startOrIsolateOrUnit;
                        startOrIsolateOrUnit = nil;
                        isolateOrUnit = 0;
                    }
                    if (isType(isolateOrUnit, STRING_TYPE)) {
                        unit = isolateOrUnit;
                    }
                    return createEntry(name, entry, timers, unit, 1, startOrIsolateOrUnit, nil, isolateOrUnit);
                },
                timeEnd: entryEnd,
                groupEnd: entryEnd,
            });
            !isolate && (cid > 1) && activeGroups.unshift(entry);
        }
        notify('start', entry, autoMeasurable);
        return entry;
    };
    api = createEntry(0, nil, Object.create(null), DEFAULT_UNIT, 1, 0, 0, 1);
    api.v = "3.0.0-rc.5";
    api.addons = addons;
    return api;
}

function domReady(fn) {
    if (document.readyState === 'complete') {
        setTimeout(fn, 0);
    }
    else {
        addEventListener$1('pageshow', fn);
    }
}

var promise;
var firstInput = function (callback) {
    try {
        if (!promise) {
            promise = new Promise(function (resolve) {
                ['keydown', 'mousedown', 'scroll', 'mousewheel', 'touchstart', 'pointerdown'].map(function (type) {
                    addEventListener$1(type, resolve, {
                        once: true,
                        passive: true,
                        capture: true,
                    });
                });
            });
        }
        promise.then(callback);
    }
    catch (_a) { }
};

var observe = function (type, handler) {
    var po;
    try {
        po = new PerformanceObserver(function (batch) {
            // console.log('🌀', type, batch.getEntries())
            batch.getEntries().map(handler);
        });
        po.observe({
            type: type,
            buffered: true,
        });
    }
    catch (_a) { }
    return po;
};
var disconnect = function (po) {
    po && po.disconnect();
};
var takeRecords = function (po, handler) {
    try {
        po && po.takeRecords().map(handler);
    }
    catch (_a) { }
};

var HIDDEN = 'hidden';
var visibilityState = 'visibilityState';
var inited = false;
var unloaded = false;
var firstTimeStamp = -1;
var hidden = function (handler, once) {
    if (!inited) {
        inited = true;
        addEventListener$1('pagehide', function (evt) {
            unloaded = !evt.persisted;
        });
        // https://bugs.chromium.org/p/chromium/issues/detail?id=987409
        addEventListener$1('beforeunload', noop);
    }
    addEventListener$1('visibilitychange', function (evt) {
        (document$1[visibilityState] === HIDDEN) && handler(evt.timeStamp, unloaded);
    }, {
        capture: true,
        once: !!once,
    });
};
if (document$1) {
    firstTimeStamp = document$1[visibilityState] === HIDDEN ? 0 : Infinity;
    hidden(function (ts) {
        firstTimeStamp = ts;
    }, true);
}
var firstHidden = function () { return firstTimeStamp; };

var create$1 = function (options) { return ({
    start: noop,
    end: function (entry) {
        if (!entry.parent) {
            print.call(options, entry);
        }
    },
}); };
function color(v, unit) {
    v = (unit === 'KB'
        ? v / 8
        : unit === 'fps'
            ? 70 - v
            : v);
    return 'color:#' + (v < 5 ? 'ccc' :
        v < 10 ? '666' :
            v < 25 ? '333' :
                v < 50 ? 'f90' :
                    v < 100 ? 'f60' :
                        'f00');
}
function print(entry) {
    var badge = this.badge;
    var unit = entry.unit;
    var dur = (entry.end - entry.start) / (unit === 'KB' ? 1024 : 1);
    var format = badge + entry.name + (unit === 'none' || !unit
        ? '%c'
        : ": %c" + (!unit || unit === 'raw' ? dur : dur.toFixed(3) + unit));
    var formatArgs = "font-weight:bold;" + color(dur, unit);
    if ('entries' in entry) {
        (console.groupCollapsed || console.group)(format, formatArgs);
        entry.entries.forEach(print, this);
        console.groupEnd();
    }
    else {
        console.log(format, formatArgs);
    }
}

var system = create({
    addons: /pk-print/.test(location) ? [create$1({ badge: '🔅' })] : [],
});
var send = function (groupName, start, end, nested, unit, meta) {
    nextFrame(function () {
        var group = system.group(groupName, start, unit);
        for (var key in nested) {
            if (nested.hasOwnProperty(key)) {
                var item = nested[key];
                group.add(key, item[0], item[1], item[2]);
            }
        }
        group.stop(end, meta);
    });
};

var _a;
// https://developer.mozilla.org/en-US/docs/Web/API/Navigator/deviceMemory
var deviceMemory = navigator.deviceMemory;
// https://developer.mozilla.org/en-US/docs/Web/API/NavigatorConcurrentHardware/hardwareConcurrency
var hardwareConcurrency = performance$1.hardwareConcurrency;
var isHighEnd = hardwareConcurrency > 4 || deviceMemory > 4;
var isLowEnd = hardwareConcurrency <= 4 || deviceMemory <= 4;
var deviceType = (isHighEnd
    ? 'high'
    : isLowEnd
        ? 'low'
        : 'unk');
var experienceType = (isLowEnd || connection && (['slow-2g', '2g', '3g'].indexOf(connection.effectiveType) > -1
    || connection.saveData)) ? 'low' : 'high';
var nested = (_a = {},
    _a["type_" + deviceType] = [0, 1],
    _a["exp_" + experienceType] = [0, 1],
    _a);
deviceMemory && (nested.memory = [0, deviceMemory]);
hardwareConcurrency && (nested.hardware_concurrency = [0, hardwareConcurrency]);
send('pk-device', 0, 1, nested, 'raw');

var state = 0;
var check = function () {
    try {
        var _a = performance$1.getEntriesByType('navigation')[0], fetchStart = _a.fetchStart, domainLookupStart = _a.domainLookupStart, domainLookupEnd = _a.domainLookupEnd, requestStart = _a.requestStart, responseStart = _a.responseStart, responseEnd = _a.responseEnd, domComplete = _a.domComplete, domInteractive = _a.domInteractive, domContentLoadedEventEnd = _a.domContentLoadedEventEnd, loadEventEnd = _a.loadEventEnd;
        if (responseEnd && state === 0) {
            state = 1;
            send('pk-nav-net', fetchStart, responseEnd, {
                'dns': [domainLookupStart, domainLookupEnd],
                'tcp': [domainLookupEnd, requestStart],
                'request': [requestStart, responseStart],
                'response': [responseStart, responseEnd],
            });
        }
        if (domComplete && state === 1) {
            state = 2;
            send('pk-nav-dom-ready', responseEnd, domComplete, {
                'interactive': [responseEnd, domInteractive],
                'content-loaded': [domInteractive, domContentLoadedEventEnd],
                'complete': [domContentLoadedEventEnd, domComplete],
            });
        }
        if (loadEventEnd && state === 2) {
            state = 3;
            send('pk-nav-dom-load', responseEnd, loadEventEnd, {
                'ready': [responseEnd, domComplete],
                'load': [domComplete, loadEventEnd],
            });
        }
        if (state !== 3) {
            setTimeout$1(check, 250);
        }
    }
    catch (_b) { }
};
check();

var conn = connection;
var check$1 = function () {
    var _a;
    send('pk-conn', 0, 1, (_a = {
            downlink: [0, conn.downlink],
            downlinkMax: [0, conn.downlinkMax],
            rtt: [0, conn.rtt]
        },
        // [`type_${conn!.type}`]: [0, 1],
        _a["save_data_" + conn.saveData] = [0, 1],
        _a["effective_type_" + (conn.effectiveType || 'unk')] = [0, 1],
        _a), 'raw');
};
try {
    if (conn) {
        check$1();
        conn.addEventListener('change', check$1);
    }
    else {
        send('pk-conn', 0, 1, { effective_type_unk: [0, 1] }, 'raw');
    }
}
catch (_a) { }

var e,n,t,r,i,a=-1,o=function(e){addEventListener("pageshow",(function(n){n.persisted&&(a=n.timeStamp,e(n));}),!0);},c=function(){return window.performance&&performance.getEntriesByType&&performance.getEntriesByType("navigation")[0]},u=function(){var e=c();return e&&e.activationStart||0},f=function(e,n){var t=c(),r="navigate";a>=0?r="back-forward-cache":t&&(document.prerendering||u()>0?r="prerender":document.wasDiscarded?r="restore":t.type&&(r=t.type.replace(/_/g,"-")));return {name:e,value:void 0===n?-1:n,rating:"good",delta:0,entries:[],id:"v3-".concat(Date.now(),"-").concat(Math.floor(8999999999999*Math.random())+1e12),navigationType:r}},s=function(e,n,t){try{if(PerformanceObserver.supportedEntryTypes.includes(e)){var r=new PerformanceObserver((function(e){Promise.resolve().then((function(){n(e.getEntries());}));}));return r.observe(Object.assign({type:e,buffered:!0},t||{})),r}}catch(e){}},d=function(e,n,t,r){var i,a;return function(o){n.value>=0&&(o||r)&&((a=n.value-(i||0))||void 0===i)&&(i=n.value,n.delta=a,n.rating=function(e,n){return e>n[1]?"poor":e>n[0]?"needs-improvement":"good"}(n.value,t),e(n));}},l=function(e){requestAnimationFrame((function(){return requestAnimationFrame((function(){return e()}))}));},p=function(e){var n=function(n){"pagehide"!==n.type&&"hidden"!==document.visibilityState||e(n);};addEventListener("visibilitychange",n,!0),addEventListener("pagehide",n,!0);},v=function(e){var n=!1;return function(t){n||(e(t),n=!0);}},m=-1,h=function(){return "hidden"!==document.visibilityState||document.prerendering?1/0:0},g=function(e){"hidden"===document.visibilityState&&m>-1&&(m="visibilitychange"===e.type?e.timeStamp:0,T());},y=function(){addEventListener("visibilitychange",g,!0),addEventListener("prerenderingchange",g,!0);},T=function(){removeEventListener("visibilitychange",g,!0),removeEventListener("prerenderingchange",g,!0);},E=function(){return m<0&&(m=h(),y(),o((function(){setTimeout((function(){m=h(),y();}),0);}))),{get firstHiddenTime(){return m}}},C=function(e){document.prerendering?addEventListener("prerenderingchange",(function(){return e()}),!0):e();},L=[1800,3e3],b=function(e,n){n=n||{},C((function(){var t,r=E(),i=f("FCP"),a=s("paint",(function(e){e.forEach((function(e){"first-contentful-paint"===e.name&&(a.disconnect(),e.startTime<r.firstHiddenTime&&(i.value=Math.max(e.startTime-u(),0),i.entries.push(e),t(!0)));}));}));a&&(t=d(e,i,L,n.reportAllChanges),o((function(r){i=f("FCP"),t=d(e,i,L,n.reportAllChanges),l((function(){i.value=performance.now()-r.timeStamp,t(!0);}));})));}));},w=[.1,.25],S=function(e,n){n=n||{},b(v((function(){var t,r=f("CLS",0),i=0,a=[],c=function(e){e.forEach((function(e){if(!e.hadRecentInput){var n=a[0],t=a[a.length-1];i&&e.startTime-t.startTime<1e3&&e.startTime-n.startTime<5e3?(i+=e.value,a.push(e)):(i=e.value,a=[e]);}})),i>r.value&&(r.value=i,r.entries=a,t());},u=s("layout-shift",c);u&&(t=d(e,r,w,n.reportAllChanges),p((function(){c(u.takeRecords()),t(!0);})),o((function(){i=0,r=f("CLS",0),t=d(e,r,w,n.reportAllChanges),l((function(){return t()}));})),setTimeout(t,0));})));},A={passive:!0,capture:!0},I=new Date,P=function(r,i){e||(e=i,n=r,t=new Date,k(removeEventListener),F());},F=function(){if(n>=0&&n<t-I){var i={entryType:"first-input",name:e.type,target:e.target,cancelable:e.cancelable,startTime:e.timeStamp,processingStart:e.timeStamp+n};r.forEach((function(e){e(i);})),r=[];}},M=function(e){if(e.cancelable){var n=(e.timeStamp>1e12?new Date:performance.now())-e.timeStamp;"pointerdown"==e.type?function(e,n){var t=function(){P(e,n),i();},r=function(){i();},i=function(){removeEventListener("pointerup",t,A),removeEventListener("pointercancel",r,A);};addEventListener("pointerup",t,A),addEventListener("pointercancel",r,A);}(n,e):P(n,e);}},k=function(e){["mousedown","keydown","touchstart","pointerdown"].forEach((function(n){return e(n,M,A)}));},D=[100,300],x=function(t,i){i=i||{},C((function(){var a,c=E(),u=f("FID"),l=function(e){e.startTime<c.firstHiddenTime&&(u.value=e.processingStart-e.startTime,u.entries.push(e),a(!0));},m=function(e){e.forEach(l);},h=s("first-input",m);a=d(t,u,D,i.reportAllChanges),h&&p(v((function(){m(h.takeRecords()),h.disconnect();}))),h&&o((function(){var o;u=f("FID"),a=d(t,u,D,i.reportAllChanges),r=[],n=-1,e=null,k(addEventListener),o=l,r.push(o),F();}));}));},B=0,R=1/0,H=0,N=function(e){e.forEach((function(e){e.interactionId&&(R=Math.min(R,e.interactionId),H=Math.max(H,e.interactionId),B=H?(H-R)/7+1:0);}));},O=function(){return i?B:performance.interactionCount||0},q=function(){"interactionCount"in performance||i||(i=s("event",N,{type:"event",buffered:!0,durationThreshold:0}));},j=[200,500],_=0,z=function(){return O()-_},G=[],J={},K=function(e){var n=G[G.length-1],t=J[e.interactionId];if(t||G.length<10||e.duration>n.latency){if(t)t.entries.push(e),t.latency=Math.max(t.latency,e.duration);else {var r={id:e.interactionId,latency:e.duration,entries:[e]};J[r.id]=r,G.push(r);}G.sort((function(e,n){return n.latency-e.latency})),G.splice(10).forEach((function(e){delete J[e.id];}));}},Q=function(e,n){n=n||{},C((function(){q();var t,r=f("INP"),i=function(e){e.forEach((function(e){(e.interactionId&&K(e),"first-input"===e.entryType)&&(!G.some((function(n){return n.entries.some((function(n){return e.duration===n.duration&&e.startTime===n.startTime}))}))&&K(e));}));var n,i=(n=Math.min(G.length-1,Math.floor(z()/50)),G[n]);i&&i.latency!==r.value&&(r.value=i.latency,r.entries=i.entries,t());},a=s("event",i,{durationThreshold:n.durationThreshold||40});t=d(e,r,j,n.reportAllChanges),a&&(a.observe({type:"first-input",buffered:!0}),p((function(){i(a.takeRecords()),r.value<0&&z()>0&&(r.value=0,r.entries=[]),t(!0);})),o((function(){G=[],_=O(),r=f("INP"),t=d(e,r,j,n.reportAllChanges);})));}));},U=[2500,4e3],V={},W=function(e,n){n=n||{},C((function(){var t,r=E(),i=f("LCP"),a=function(e){var n=e[e.length-1];n&&n.startTime<r.firstHiddenTime&&(i.value=Math.max(n.startTime-u(),0),i.entries=[n],t());},c=s("largest-contentful-paint",a);if(c){t=d(e,i,U,n.reportAllChanges);var m=v((function(){V[i.id]||(a(c.takeRecords()),c.disconnect(),V[i.id]=!0,t(!0));}));["keydown","click"].forEach((function(e){addEventListener(e,m,!0);})),p(m),o((function(r){i=f("LCP"),t=d(e,i,U,n.reportAllChanges),l((function(){i.value=performance.now()-r.timeStamp,V[i.id]=!0,t(!0);}));}));}}));},X=[800,1800],Y=function e(n){document.prerendering?C((function(){return e(n)})):"complete"!==document.readyState?addEventListener("load",(function(){return e(n)}),!0):setTimeout(n,0);},Z=function(e,n){n=n||{};var t=f("TTFB"),r=d(e,t,X,n.reportAllChanges);Y((function(){var i=c();if(i){var a=i.responseStart;if(a<=0||a>performance.now())return;t.value=Math.max(a-u(),0),t.entries=[i],r(!0),o((function(){t=f("TTFB",0),(r=d(e,t,X,n.reportAllChanges))(!0);}));}}));};

var getVitalsScore = function (value, min, max) { return (value <= min
    ? 'good'
    : value <= max
        ? 'needs-improvement'
        : 'poor'); };

var ttb = 0;
var tti = 0;
var perf;
var handler = function (entry) {
    var _a, _b;
    var startTime = entry.startTime;
    var value = entry.processingStart - startTime;
    if (startTime < firstHidden()) {
        // https://web.dev/lighthouse-total-blocking-time/
        // https://nitropack.io/blog/post/what-is-total-blocking-time-tbt
        // 0-200     Green (good)
        // 600-600   Orange (needs improvement)
        // Over 600  Red (poor)
        ttb && send('pk-tbt', 0, ttb, (_a = {
                value: [0, ttb]
            },
            _a["score_" + getVitalsScore(ttb, 200, 600)] = [0, ttb],
            _a));
        // https://web.dev/interactive/
        // 0-3800     Green (good)
        // 3800-7300  Orange (needs improvement)
        // Over 7300  Red (poor)
        tti && send('pk-tti', 0, tti, (_b = {
                value: [0, tti]
            },
            _b["score_" + getVitalsScore(tti, 3800, 7300)] = [0, ttb],
            _b));
        disconnect(perf);
        disconnect(fid);
    }
};
var fid = observe('first-input', handler);
hidden(function () {
    takeRecords(fid, handler);
}, true);
var initPerf = function (fcpTime) {
    perf = observe('longtask', function (entry) {
        var startTime = entry.startTime;
        var duration = entry.duration;
        if (startTime > fcpTime && entry.name === 'self') {
            // The main thread is considered "blocked" any time there's a Long Task—a task
            // that runs on the main thread for more than 50 milliseconds (ms).
            var blocked = duration - 50;
            if (duration > 0) {
                ttb += blocked;
                tti = startTime + duration;
            }
        }
    });
};

var useWebVitals = function () {
    var sendMetric = function (name, _a) {
        var _b;
        var value = _a.value, rating = _a.rating;
        send("pk-" + name, 0, value, (_b = {
                value: [0, value]
            },
            _b["score_" + rating] = [0, value],
            _b));
    };
    var use = function (name, onMetric) {
        onMetric(function (data) {
            sendMetric(name, data);
        });
    };
    //
    // Подписываемся на сбор метрик
    //
    b(function (data) {
        initPerf(data.value);
        sendMetric('paint', data);
    });
    use('cls', S);
    use('lcp', W);
    use('fid', x);
    use('inp', Q);
    use('ttfb', Z);
};

useWebVitals();

export { BOOLEAN_TYPE, FUNCTION_TYPE, OBJECT_TYPE, STRING_TYPE, addEventListener$1 as addEventListener, connection, console, create, disconnect, document$1 as document, domReady, firstHidden, firstInput, hidden, hiddenProperty, isType, location, navigator, nextFrame, noop, observe, perfNow, performance$1 as performance, setTimeout$1 as setTimeout, system, send as systemSend, takeRecords };
